import { render, staticRenderFns } from "./PrecoCustoProduto.vue?vue&type=template&id=a58a20dc&scoped=true"
import script from "./PrecoCustoProduto.vue?vue&type=script&lang=js"
export * from "./PrecoCustoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a20dc",
  null
  
)

export default component.exports